<template>
  <div class="top-rolling" v-if="data.length > 0">
    <Rolling ref="rolling">
      <div v-for="(item, index) in data" :key="index + 'rolling'">
        {{ item.content }}
      </div>
    </Rolling>
  </div>
</template>

<script>
import Rolling from '@/components/UI/Rolling';
export default {
  props: {
    data: {
      default: () => [],
      type: Array
    }
  },
  components: {
    Rolling
  }
};
</script>

<style lang="less" scoped>
.top-rolling {
  width: 600px;
  height: 50px;
  // position: absolute;
  // top: 19px;
  // left: 50%;
  // transform: translate(-50%, 0);
  // background: rgba(255, 255, 255, 0.5);
  font-weight: 500;
  // color: #8f0000;
  text-align: center;
  font-size: 25px;
  .fc;
}
</style>
